import { Button, ButtonMode, ButtonSize, Modal, ModalWidth } from '@creditsights/styleguide-web';
import React, { ReactElement, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { useSetRecoilState } from 'recoil';
import { toasterState } from '../../atoms/toaster.atom';
import { USER_WATCHLISTS_KEY } from '../../Constants';
import useSaveWatchlist from '../../hooks/user/useSaveWatchlist';

import './NewWatchlistModal.scss';

type WatchlistNameForm = {
  name: string;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function NewWatchlistModal({ open, companies, invalidNames, onClose }): ReactElement {
  const queryClient = useQueryClient();
  const showToaster = useSetRecoilState(toasterState);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<WatchlistNameForm>({ mode: 'onChange' });
  const { mutate: saveWatchlist, isLoading, reset, isSuccess } = useSaveWatchlist();

  useEffect(() => {
    if (isSuccess) {
      reset();
      queryClient.invalidateQueries([USER_WATCHLISTS_KEY]);
    }
  }, [isSuccess]);
  const isUnique = (name) => (invalidNames.indexOf(name.trim()) === -1 ? true : 'Name already exists');
  const onSubmit = ({ name }) => {
    // eslint-disable-next-line no-param-reassign
    name = name.trim();
    if (name) {
      saveWatchlist(
        {
          watchlist: {
            name,
            myCS: true,
            mode: 'Instant',
            tags: companies,
          },
        },
        {
          onSuccess: () => {
            showToaster({
              text: `Companies were successfully added to your new watchlist ${name}`,
              bold: true,
            });

            onClose();
          },
        }
      );
    }
  };

  return (
    <Modal className="cs-new-watchlist-modal" headerTitle="New Watchlist" open={open} width={ModalWidth.Small} closeOnEscape closeOnButtonClick onClose={onClose}>
      <form className="ui form" onSubmit={handleSubmit(onSubmit)}>
        <div className="field">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Watchlist Name</label>
          <input type="text" autoComplete="off" {...register('name', { validate: { isUnique }, required: { value: true, message: 'Name is required' }, maxLength: { value: 200, message: 'Name is too long' } })} placeholder="Enter Watchlist Name" />
          {errors.name && <div className="error-message">{errors.name.message}</div>}
        </div>
        <div className="buttons-ctx">
          <Button mode={ButtonMode.SECONDARY} size={ButtonSize.MEDIUM} disabled={isLoading} onClick={() => onClose()}>
            Cancel
          </Button>
          <Button mode={ButtonMode.PRIMARY} size={ButtonSize.MEDIUM} type="submit" disabled={isLoading || errors.name !== undefined}>
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default NewWatchlistModal;
